import { useContext } from 'react'
import { AuthContext, AuthContextProps } from '../services/auth/AuthContext';

const useLogout = () => {
    const { logout } = useContext<AuthContextProps>(AuthContext);
    return logout;
}

export default useLogout
